import { Grid } from "@mui/material";
import MxFormL3TextThousandField from "@rf-l3/form/MxFormL3TextThousandField";
import { CModalSchemaKeys } from "./BuildingUnitFormModal";
import MxFormSubTitle from "@rf-l1/page/form/MxFormSubTitle";

const FeaturesDimensions = () => {
  return (
    <Grid container spacing={1} rowGap={2}>
      <Grid item xs={12}>
        <MxFormSubTitle label="Especifica las dimensiones" />
      </Grid>
      <Grid item xs={12} md={6}>
        <MxFormL3TextThousandField
          name={CModalSchemaKeys.metersConstruction}
          label="Metros de construcción"
          withreacthookform={1}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <MxFormL3TextThousandField
          name={CModalSchemaKeys.metersLand}
          label="Metros de solar"
          withreacthookform={1}
        />
      </Grid>
    </Grid>
  );
};

export default FeaturesDimensions;
